import React from 'react'
import styles from './mainMenu.module.css'
import Button from './Button'
import { withInjectableUi } from './extendableSystem'

interface Props {
  loadReplayAction?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const ReplayMainMenuBase = ({ loadReplayAction }: Props) => {
  return (
    <div
      data-replay-main-menu='true'
      className={styles.root}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'var(--app-bg)',
      }}
    >
      <div className={styles['game-title']}>
        <div style={{
          fontSize: 42,
          letterSpacing: 1,
          textShadow: '2px 2px #000',
          userSelect: 'none'
        }}>
          Replay Engine
        </div>
      </div>

      <div className={styles.menu}>
        <div style={{
          color: 'white',
          textShadow: '1px 1px #222',
          fontSize: 12,
          lineHeight: 1.35,
          textAlign: 'center',
          marginBottom: 4,
          userSelect: 'none'
        }}>
          <div>Drag & drop a replay file into the window</div>
          <div>or click the button below</div>
        </div>

        <Button onClick={loadReplayAction}>Load Replay</Button>
      </div>
    </div>
  )
}

export default withInjectableUi(ReplayMainMenuBase, 'replayMainMenu')
